const SAFE_URL_PROTOCOLS = ['http:', 'https:']

// URLs supplied by the backend (hotel operators / CMS) end up in window.open.
// Only http(s) is allowed: a javascript: URL would run script in this origin,
// and data: or custom schemes could launch arbitrary content or native apps.
// Relative paths resolve against this origin, so they are allowed as well.
export const isSafeHttpUrl = (url?: string | null): url is string => {
  if (!url) {
    return false
  }

  try {
    const { protocol } = new URL(url, window.location.origin)
    return SAFE_URL_PROTOCOLS.includes(protocol)
  } catch (e) {
    return false
  }
}
